'use strict';

module.exports = {
  CONVERT_JOULES_TO_CALORIES: 4186.8,
  ONE_KILOMETER_IN_METERS: 1000,
  TO_PERCENT: 100,
};
